import React from "react";
import "./descriptionList.css"

interface DescriptionListProps {
    title: string,
    value: string | number | JSX.Element
}
 
interface DescriptionListState {
    
}
 
class DescriptionList extends React.Component<DescriptionListProps, DescriptionListState> {
    constructor(props:DescriptionListProps){
        super(props);
    }
    render() { 
        return (
            <dl className="data-description">
                <dt>{this.props.title}</dt>
                <dd>{this.props.value}</dd>
            </dl>
        );
    }
}
 
export default DescriptionList;